export default class BillingCode {
    clientNumber?: number;
    prospectNumber?: number;
    sectionNumber?: number;
    unitNumber?: number;
    activityType?: string;

    public toString(): string {
        let billingCodeString = '';
        if (!this.clientNumber && !this.prospectNumber) {
            return billingCodeString;
        } else {
            billingCodeString = this.clientNumber.toString() + '.' + this.prospectNumber;
            billingCodeString += this.sectionNumber ? ('.' + this.sectionNumber) : '.0';
            billingCodeString += this.unitNumber ? ('.' + this.unitNumber) : '.0';
        }
        return billingCodeString;
    }
}


// WEBPACK FOOTER //
// ./src/models/AP/BillingCode.ts